var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCruise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2346",
    "data-name": "Group 2346",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.936,
    height: 14.087,
    viewBox: "0 0 20.936 14.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5128",
    "data-name": "Path 5128",
    d: "M22.343,91.264l-1.875.194L18.82,88.746a.584.584,0,0,0-.5-.28h-.841L15.7,85.3A.577.577,0,0,0,15.2,85H6.721a.58.58,0,0,0-.581.581v2.885H4.932a.58.58,0,0,0-.581.581v4.071L2.575,93.3a.582.582,0,0,0-.47.82L3.375,96.9a2.811,2.811,0,0,0-.779.548.583.583,0,0,0,.824.824,1.615,1.615,0,0,1,2.291,0,2.787,2.787,0,0,0,3.936,0,1.624,1.624,0,0,1,2.291,0,2.788,2.788,0,0,0,3.936,0,1.624,1.624,0,0,1,2.291,0,2.777,2.777,0,0,0,3.936,0,.583.583,0,0,0-.824-.824,1.6,1.6,0,0,1-1.9.28L22.9,92.154A.586.586,0,0,0,22.343,91.264ZM7.3,86.166H14.86l1.29,2.3H7.3ZM5.513,89.632H18l1.191,1.957L5.513,93Zm12.919,7.4a2.781,2.781,0,0,0-3.387.42,1.616,1.616,0,0,1-2.291,0,2.788,2.788,0,0,0-3.936,0,1.624,1.624,0,0,1-2.291,0,2.758,2.758,0,0,0-1.995-.816L3.5,94.379l17.774-1.834Z",
    transform: "translate(-2.054 -85)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5129",
    "data-name": "Path 5129",
    d: "M123.137,214.1h-.255a.581.581,0,1,0,0,1.162h.255a.581.581,0,1,0,0-1.162Z",
    transform: "translate(-117.345 -208.78)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5130",
    "data-name": "Path 5130",
    d: "M186.937,214.1h-.255a.581.581,0,1,0,0,1.162h.255a.581.581,0,1,0,0-1.162Z",
    transform: "translate(-178.516 -208.78)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5131",
    "data-name": "Path 5131",
    d: "M250.637,214.1h-.255a.581.581,0,1,0,0,1.162h.255a.581.581,0,1,0,0-1.162Z",
    transform: "translate(-239.59 -208.78)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5132",
    "data-name": "Path 5132",
    d: "M314.337,214.1h-.255a.581.581,0,1,0,0,1.162h.255a.581.581,0,1,0,0-1.162Z",
    transform: "translate(-300.665 -208.78)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5133",
    "data-name": "Path 5133",
    d: "M147.437,127.2h-.256a.581.581,0,1,0,0,1.162h.256a.581.581,0,0,0,0-1.162Z",
    transform: "translate(-140.643 -125.461)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5134",
    "data-name": "Path 5134",
    d: "M211.237,127.2h-.255a.581.581,0,1,0,0,1.162h.255a.581.581,0,1,0,0-1.162Z",
    transform: "translate(-201.814 -125.461)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5135",
    "data-name": "Path 5135",
    d: "M274.937,127.2h-.255a.581.581,0,1,0,0,1.162h.255a.581.581,0,1,0,0-1.162Z",
    transform: "translate(-262.889 -125.461)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCruise);
export default __webpack_public_path__ + "static/media/cruise.6a8f53d5.svg";
export { ForwardRef as ReactComponent };